import { FormEngineModeTypeEnum } from '@celito.clients/enums';
import { Loader, Stack } from '@celito.clients/shared';
import React from 'react';

import { WizardStepType } from '../../enums/wizard-enum';
import CurrentTypeSectionView from './types/current-type';
import ErrorTypeSectionView from './types/error-type';
import InactiveTypeSectionView from './types/inactive-type';
import SuccessTypeSectionView from './types/success-type';
import { WizardStepsProps } from './wizard-steps.model';
import classes from './wizard-steps.module.css';

const getWizardStepWrapper = (
  state: string,
  label: string,
  index: number,
  onClick: () => void
) => {
  const props = { label, index: index + 1, onClick };
  switch (state) {
    case WizardStepType.CURRENT:
      return <CurrentTypeSectionView {...props} />;
    case WizardStepType.INACTIVE:
      return <InactiveTypeSectionView {...props} />;
    case WizardStepType.SUCCESS:
      return <SuccessTypeSectionView {...props} />;
    case WizardStepType.ERROR:
      return <ErrorTypeSectionView {...props} />;
    default:
      return <InactiveTypeSectionView {...props} />;
  }
};

const WizardSteps: React.FC<WizardStepsProps> = ({
  sections = [],
  onStepClick,
  mode,
  step,
  wizardStepsState,
  recordDetails,
}) => {
  const getWizardChild = (
    label: string,
    mode: FormEngineModeTypeEnum,
    step: number
  ) => {
    const currentStepState = wizardStepsState.find(
      (step) => step.label === label
    );

    if (currentStepState?.label === sections[step]?.label) {
      // current step should not reflect error state even if it has
      return WizardStepType.CURRENT;
    }

    if (!currentStepState) {
      return WizardStepType.INACTIVE;
    }

    if (currentStepState.isValid === undefined) {
      return WizardStepType.INACTIVE;
    }

    if (mode === FormEngineModeTypeEnum.CustomView) {
      return WizardStepType.INACTIVE;
    }

    return currentStepState.isValid
      ? WizardStepType.SUCCESS
      : WizardStepType.ERROR;
  };

  return (
    <Stack data-testid="wizard-step" className={classes.container}>
      {Object.keys(recordDetails).length <= 0 &&
      mode !== FormEngineModeTypeEnum.Create ? (
        <div className={classes.loader}>
          <Loader />
        </div>
      ) : (
        sections.map((section, index) => {
          return (
            <React.Fragment key={section.name}>
              {getWizardStepWrapper(
                getWizardChild(section.label, mode, step),
                section.label,
                index,
                () => onStepClick(index)
              )}
            </React.Fragment>
          );
        })
      )}
    </Stack>
  );
};

export default WizardSteps;
